import { AHText, AHTextFonts } from "arkh";
import { FormattedMessage } from "react-intl";
import React from "react";

import { graphql, useFragment } from "react-relay";
import { IntegrationAdminListItem } from "./components/IntegrationAdminListItem";

import { useNavigation } from "@react-navigation/native";
import { IntegrationAdminFlyerListItem_IntegrationEmaginFlyer$key } from "./__generated__/IntegrationAdminFlyerListItem_IntegrationEmaginFlyer.graphql";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import { FormattedDateRaw } from "../../common/dates/useFormattedDateRaw";

export function IntegrationAdminFlyerListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  flyer: IntegrationAdminFlyerListItem_IntegrationEmaginFlyer$key;
}) {
  const navigation =
    useNavigation<StoreAdminNavigationProp<"IntegrationAdmin">>();

  const flyer = useFragment(
    graphql`
      fragment IntegrationAdminFlyerListItem_IntegrationEmaginFlyer on IntegrationEmaginFlyer {
        __typename
        id
        eMaginId
        status
        lastCheckedAt
        title
        lastError
      }
    `,
    props.flyer
  );
  return (
    <IntegrationAdminListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={() => {
        navigation.navigateDeprecated("IntegrationFlyer", {
          id: flyer.id,
          title: flyer.title,
          lastCheckedAt: flyer.lastCheckedAt,
          lastError: flyer.lastError,
          status: flyer.status,
        });
      }}
      active={flyer.status === "success"}
      pending={flyer.status === "pending"}
    >
      <AHText type="title-small" font={AHTextFonts.REGULAR} numberOfLines={1}>
        {flyer.title}
      </AHText>
      {flyer.lastError ? (
        <AHText>
          <FormattedMessage
            defaultMessage="Failing"
            description="StoreAdminActiveIntegrations failing"
          />
          : {flyer.lastError}
        </AHText>
      ) : (
        <AHText>
          <FormattedMessage
            defaultMessage="last checked at {time}"
            description="StoreAdminActiveIntegrations LastCheckedAt"
            values={{
              time: flyer.lastCheckedAt ? (
                <FormattedDateRaw
                  style="DEFAULT"
                  dateISO={flyer.lastCheckedAt}
                />
              ) : (
                ""
              ),
            }}
          />
        </AHText>
      )}
    </IntegrationAdminListItem>
  );
}
